<template>
	<page-content-layout class="invoicing" title="Fakturering">
		<button-view v-if="false" slot="tools" label="Opret" />
		<button-group-view v-if="false" slot="tools" :actions="[
			{
				label: 'Modtaget',
				value: 'received'
			},
			{
				label: 'Åben',
				value: 'open'
			},
			{
				label: 'Lukket',
				value: 'closed'
			}
		]" v-model="active" />
		<button-view v-if="checked.length > 0" slot="tools" label="Marker som faktureret" @click="invoiced" />
		<button-view v-if="checked.length > 0" slot="tools" label="Fakturer" @click="select" />
		<new-table-view ref="table" v-model="checked" :columns="[
		{
				label: 'Oprettet',
				name: 'created',
				filter: 'date',
				weight: 2
			},
			{
				label: 'Ordrenr.',
				name: 'num',
				weight: 2
			},
			{
				label: 'Kunde',
				name: ['customer', 'name'],
				weight: 3
			},
			{
				label: 'Beløb',
				name: ['_calculated', 'total'],
				align: 'right',
				filter: 'number',
				weight: 2
			},
			{
				label: 'Bemærkninger',
				name: 'remarks',
				weight: 5
			}
		]" :items="_items" @itemClick="itemClick" @context="itemContext" />
	</page-content-layout>
</template>

<script>
	import OrderMixin from '../../mixins/OrderMixin';

	import Window from '../windows/ClaimWindow'
	import MailWindow from '../windows/MailWindow'
	import NewInvoiceWindow from '../windows/NewInvoiceWindow'
	import TextWindow from '../windows/TextWindow'
	import EmployeeHistoryWindow from '../windows/EmployeeHistoryWindow'
	import NewTableView from '../views/NewTableView'
	import ContextPopupView from '../views/ContextPopupView'

	import MoveTaskModel from '../model/MoveTask'
	import MoveTaskWindow from '../windows/MoveTaskWindow'

	import OrderModel from '../model/Order'
	import InvoiceModel from '../model/Invoice'
	import OrderWindow from '../windows/OrderWindow'

	import { bus } from '../../bus'

    export default {
		mixins: [ OrderMixin ],
		data() {
			return {
				templates: [],
				items: [],
				active: 'received',
				checked: []
			};
		},
		components: {
			newTableView: NewTableView
		},
		computed: {
			_items() {
				const self = this;

				return this.items?.map((val) => {
					val._calculated = {
						total: self.$_OrderMixin_total(val.order_lines)
					};

					return val;
				}) || []; 
			},
			_status() {
				return {
					received: 'Modtaget',
					open: 'Åben',
					closed: 'Lukket'
				};
			},
			_statusDesc() {
				return this._status;
			},
			_statusColors() {
				return {
					received: 'yellow',
					open: 'yellow',
					closed: 'green'
				};
			}
		},
		methods: {
			async invoiced() {
				

				if (!confirm('Er du sikker?')) return;

				await this.axios.put('/invoices/handled/', {
					invoices: this.checked
				});

				this.update();
			},
			async select(event) {
				var self = this;

				const templates = this.templates;

				var actions = [];

				for (const tmpl of templates) {
					actions.push({
						label: tmpl.label,
						action() {
							self.$store.state.windowStack.push(NewInvoiceWindow, {
								value: {
									entity: {
										contact_id: 	self.checked.reduce((prev, val) => { return prev === null ? null : (prev == 0 ? val.contact_id : (prev != val.contact_id ? null : prev)); }, 0),
										department_id: 	self.$store.state.employee.department_id
									},
									orders: self.checked,
									template: tmpl
								}, 
								submit: async function (entity, doEmail, doPost) {
									// Save invoice here
									
									return await InvoiceModel.save(this.axios, entity, doEmail, doPost);
								}
							});
						}
					});
				}

				

				this.$store.state.popupController.toggle(ContextPopupView, {
					anchor: event.target,
					align: 'right',
					actions: actions
				});
			},
			async updateInvoiceTemplates() {
				const r = (await this.axios.get(`/integrations/economic/payment-terms/`)).data;

				r.sort((a, b) => {
					return a.name > b.name ? 1 : -1;
				});

				this.templates = r.map((item) => {
					return {
						label: item.name,
						id: 'ljtransport_auto',
						version: 0,
						_embedded: {
							description: item.description || ''
						}
					};
				});
			},
			update() {
				var self = this;

				self.items = null;

				this.axios
					.get('/sales/orders/not-invoiced/header/')
					.then(function (r) {
						self.items = r.data._items;

						
					});

				this.updateInvoiceTemplates();
			},
			async itemClick(item) {
				const id = item.id;

				if (!id) {
					alert('Denne opgave har ingen ordre');
					return;
				}

				

				var self = this;
				var order = {};
				
				var ent = id ? await OrderModel.read(self.axios, id) : OrderModel.entity();

				if (!id) {
					ent.employee_id 		= self.$store.state.employee.id;
					ent.department_id 		= self.$store.state.employee.department_id;
					ent._embedded.employee	= self.$store.state.employee;
				}

				this.$store.state.windowStack.push(OrderWindow, {
					value: ent, 
					submit: async function (entity, invoice = false, paid = false) {
						if ((order = await OrderModel.save(self.axios, entity, invoice, paid))) {
							//self.$store.state.windowStack.pop();
							//bus.$emit('update');
						}
					}
				});
			},
			itemDelete(item) {
				if (!confirm('Sikker?')) return;

				var view = this;

				this.axios
					.delete('/claims/' + item.id + '/')
					.then(function (r) {
						

						if (r.status >= 200 && r.status < 300) {
							view.update();
						}

						
					}, function (err) {
						
						
						var r = err.response;

						if (r.status == 422) {
							alert(r.data);
						} else {
							alert('Server Error');
						}
					});	
			},
			itemContext(item, event) {
				event.stopPropagation();

				

				var self = this;

				var actions = [
					{
						label: 'Åben opgave',
						action: async function () {
							// Expecting a move task
							var ent = await MoveTaskModel.read(self.axios, item.task_id);

							self.$store.state.windowStack.push(MoveTaskWindow, {
								value: ent,
								async submit(entity) {
									if (await MoveTaskModel.save(self.axios, entity)) {
										self.$store.state.windowStack.pop();
										bus.$emit('update');
									}
								}
							});
						}
					},
					null,
					{
						label: 'Send til e-mail',
						action: async function () {
							const email = prompt('E-mail');

							if (!email) return;

							await self.axios.post(`/claims/${item.id}/email`, {
								email: email
							});
						}
					},
					{
						label: 'Udbed kommentarer',
						action: async function () {
							const email = prompt('E-mail', item._embedded.employees.map((item) => {
								return item.email;
							}).join(', '));

							if (!email) return;

							await self.axios.post(`/claims/${item.id}/comments`, {
								email: email
							});
						}
					},
					null,
					{
						label: 'Vis billeder fra anmeldelse',
						action() {
							self.$store.commit('gallery', item.details.files.filter((item) => { 
								const parts = item.label.split('.');
								const last = parts[parts.length - 1].toString().toLowerCase();

								return last == 'jpg' || last == 'jpg' || last == 'png';
							}));
						}
					},
					{
						label: 'Vis billeder fra opgave',
						action() {
							self.$store.commit('gallery', item._embedded.task.hasOwnProperty('details') && item._embedded.task.details.hasOwnProperty('photos') ? item._embedded.task.details.photos : []);
						}
					},
					{
						label: 'Sammenlign billeder',
						action() {
							self.$store.commit('cmp_gallery_1', item.details.files.filter((item) => { 
								const parts = item.label.split('.');
								const last = parts[parts.length - 1].toString().toLowerCase();

								return last == 'jpg' || last == 'jpg' || last == 'png';
							}));

							self.$store.commit('cmp_gallery_2', item._embedded.task.hasOwnProperty('details') && item._embedded.task.details.hasOwnProperty('photos') ? item._embedded.task.details.photos : []);
						}
					},
				];

				actions.push(null);

				actions.push({
					label: 'Slet',
					action: async function () {
						self.itemDelete(item);
					}
				});


				this.$store.state.popupController.toggle(ContextPopupView, {
					anchor: event.currentTarget,
					align: 'left',
					actions: actions
				});
			},
		},
		mounted: function () {
			this.axios.put('/activity/invoicing/');

			this.update();

			var self = this;

			bus.$on('update', function () {
				self.update();
			});

			bus.$on('clear', function () {
				self.items = null;
			});


			/*this.axios
				.all([
					this.axios.get('/contacts/'),
					this.axios.get('/contacts/columns/')
				]).then(function (results) {
					
				});*/
		},
		beforeRouteLeave(to, from, next) {
			bus.$off('update');
			bus.$off('clear');

			next();
		}
    }
</script>

<style lang="scss">

</style>